import { v4 as uuidv4 } from 'uuid';

import {
  CHECK_CARD_ERRORS_STEP,
  CONFIRMATION_FORM_STEP,
  HOW_MUCH_STEP,
  IS_THAT_CORRECT_STEP,
  WHICH_ACCOUNT_STEP
} from '#client/constants/transfer';

import {
  ACCOUNT_COULD_NOT_SET_UP,
  INSTANT_DEPOSIT_STEP_LIST,
  LOADING_STEP,
  MODAL_ACTION
} from '../constants/instants';

export const initState = (initialFormValue) => {
  const depositInitData = {
    loading: false,
    currentFormStep: initialFormValue?.initStep || HOW_MUCH_STEP,
    selectedFromAccount: initialFormValue?.selectedFromAccount || {},
    toAccount: {},
    amount: 0,
    expectedDate: null,
    initialDate: null,
    createTransferError: null,
    idempotencyKey: '',
    status: null,
    instantTransferRoutineUuid: null,
    transferStatus: null,
    transferReason: null,
    createAstraCardError: initialFormValue?.createAstraCardError || null
  };

  return Object.defineProperty(depositInitData, 'idempotencyKey', {
    value: uuidv4(),
    writable: false,
    enumerable: true
  });
};

export const depositReducer = (state, action) => {
  const currentStepIndex = INSTANT_DEPOSIT_STEP_LIST.indexOf(state.currentFormStep);

  switch (action.type) {
    case MODAL_ACTION.TRY_AGAIN:
      return {
        ...initState()
      };
    case MODAL_ACTION.GO_TO_HOW_MUCH_FORM:
      return {
        ...state,
        ...action.payload,
        currentFormStep: HOW_MUCH_STEP
      };
    case MODAL_ACTION.GO_TO_IS_THIS_CORRECT_FORM:
      return {
        ...state,
        ...action.payload,
        currentFormStep: IS_THAT_CORRECT_STEP
      };
    case MODAL_ACTION.GO_TO_LOADING_STEP:
      return {
        ...state,
        ...action.payload,
        currentFormStep: LOADING_STEP
      };
    case MODAL_ACTION.GO_TO_ACCOUNT_COULD_NOT_SET_UP:
      return {
        ...state,
        ...action.payload,
        currentFormStep: ACCOUNT_COULD_NOT_SET_UP
      };
    case MODAL_ACTION.GO_TO_CONFIRMATION:
      return {
        ...state,
        ...action.payload,
        currentFormStep: CONFIRMATION_FORM_STEP
      };
    case MODAL_ACTION.GO_TO_WHICH_CARD_FORM:
      return {
        ...state,
        ...action.payload,
        currentFormStep: WHICH_ACCOUNT_STEP
      };
    case MODAL_ACTION.GO_TO_CHECK_CARD_ERRORS:
      return {
        ...state,
        ...action.payload,
        currentFormStep: CHECK_CARD_ERRORS_STEP
      };
    case MODAL_ACTION.BACK:
      return {
        ...state,
        ...action.payload,
        currentFormStep: INSTANT_DEPOSIT_STEP_LIST[currentStepIndex - 1]
      };
    default:
      return state;
  }
};
